import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import ModalBox from "@/shared/components/modal-box/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";

@Options({
  props: {
    selectedPractice: Object,
  },
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  },
  mixins: [FormatDateTimeMixin]
})
export default class ViewTerminatePracticeModal extends Vue {
  private selectedPractice!: any;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private inEditMode = false;
  private submitButtonPressed = false;
  private terminated = false;
  private submitting = false;

  private isLoading = false;
  private practice: any = {};

  @Watch('terminated')
  private onTerminatedChanged(): void {
    if (this.terminated) {
      this.practice.effectiveEndDate = new Date();
    } else {
      this.practice.effectiveEndDate = null;
    }
  }

  private closeModal(): void {
    this.$emit('close');
  }

  mounted(): void {
    this.inEditMode = this.selectedPractice.effectiveEndDate ? false : true;
    this.getPractice();
  }

  private async getPractice(): Promise<void> {
    this.isLoading = true;
    await this.apiService?.PracticeAtcsApi?.apiV2AtcsPracticeAdminGetIndividualPracticeForExternalExaminerIndividualPracticeIdGet(
      this.selectedPractice.individualPracticeId
    ).then((response) => {
      this.practice = response.data.data;
      if (this.inEditMode) {
        this.practice.terminationReason = '';
      }
      this.isLoading = false;
    }).catch((error) => {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Practice data: ' + error);
      this.ai.trackException('Error getting Practice data: ' + error);
      this.isLoading = false;
    });
  }

  private isFormValid(): boolean {
    return this.practice.effectiveEndDate != null && this.practice.terminationReason != '';
  }

  private async save(): Promise<void> {
    try {
      this.submitButtonPressed = true;
      this.submitting = true;
      if (!this.isFormValid()) {
        throw ('Incomplete form data');
      }
      const res = await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(
        {
          "id": this.selectedPractice.individualPracticeId,
          "effectiveEndDate": new Date(),
          "terminationReason": this.practice.terminationReason,
        }
      )
      this.eventCtrl.emit('show-snackbar', 'success', 'Practice terminated successfully');
      this.$emit('refresh');
      this.closeModal();
    }
    catch (error) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error terminating Practice: ' + error);
      this.ai.trackException('Error terminating Practice: ' + error);

    }
    finally {
      this.submitting = false;
    }
  }



  //   if (this.inEditMode) {

  //     await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeAdminTerminateIndividualPracticeForExternalExaminerPost(
  //       {
  //         "id": this.selectedPractice.individualPracticeId,
  //         "effectiveEndDate": new Date(),
  //         "terminationReason": this.practice.terminationReason,
  //       }
  //     )
  //       .then(() => {
  //         this.eventCtrl.emit('show-snackbar', 'success', 'Practice terminated successfully');
  //         this.submitting = false;
  //         this.$emit('refresh');
  //         this.closeModal();
  //       })
  //       .catch((error) => {
  //         this.eventCtrl.emit('show-snackbar', 'error', 'Error terminating Practice: ' + error);
  //         this.ai.trackException('Error terminating Practice: ' + error);
  //         this.submitting = false;
  //       });
  //   }
  // }

}

